import { render, staticRenderFns } from "./LogisticMenu.vue?vue&type=template&id=4c0772d6&scoped=true&"
import script from "./LogisticMenu.vue?vue&type=script&lang=js&"
export * from "./LogisticMenu.vue?vue&type=script&lang=js&"
import style0 from "./LogisticMenu.vue?vue&type=style&index=0&id=4c0772d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0772d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VContainer,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VRow,VSlideGroup,VSlideItem})
